<template>
  <div class="flex">
    <div v-for="(item, i) in data" :key="item.name" :class="['diff', `diff-${i}`]">
      <h2>{{ item.name }}</h2>
      <p class="desc">{{ item.desc }}</p>
      <div v-if="item.scenes.length" class="mb-[40px]">
        <p class="desc-title">{{ $t('shi-he-yi-xia-chang-jing') }}</p>
        <a-space :size="[0, 8]" wrap>
          <a-tag
            v-for="tag in item.scenes"
            :key="tag"
            :style="{ color: item.scenesColor }"
            :color="item.scenesBg"
          >
            #{{ tag }}
          </a-tag>
        </a-space>
      </div>
      <div v-if="item.disScenes.length">
        <p class="desc-title">{{ $t('bu-shi-he-yi-xia-chang-jing') }}</p>
        <a-space wrap>
          <a-tag
            v-for="tag in item.disScenes"
            :key="tag"
            :style="{ color: item.disscenesColor }"
            :color="item.disscenesBg"
          >
            #{{ tag }}
          </a-tag>
        </a-space>
      </div>
      <div v-show="item.isTip" class="tip">
        {{
          $t(
            'ru-guo-ni-shi-qi-ye-yuan-gong-mei-ti-cong-ye-zhe-zhi-zuo-de-shi-pin-shou-yi-fang-shi-qi-ye-gong-zuo-shi-qing',
          )
        }}
        <span :class="onSubscribeCb ? 'tip-bold' : ''" @click="onSubscribe">
          {{ $t('xuan-ze-qi-ye-shang-yong-ban') }}
        </span>
        ！
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { actionUpdateCycle } from '~/composables/rights.ts';
import { PageKey } from '~/constants/page';

const props = defineProps<{
  onSubscribeCb?(): void;
}>();

const { $t } = useNuxtApp();

const data = ref([
  {
    name: $t('ge-ren-shang-yong-shou-quan'),
    desc: $t(
      'ge-ren-shang-yong-shou-quan-chan-pin-ji-shi-pin-jin-xian-yong-yu-yi-ge-ren-wei-zhu-ti-cong-shi-de-shang-shi-huo-dong-zhong-qie-bao-zheng-ying-li-ji-zui-zhong-de-shou-yi-zhu-ti-wei-ge-ren',
    ),
    scenes: [
      $t('ge-ren-xin-mei-ti-zhang-hao'),
      $t('ge-ren-wang-zhan'),
      $t('ge-ti-shang-pu'),
      $t('ge-ren-zhi-bo-dai-huo'),
    ],
    scenesColor: '#FFFFFF',
    scenesBg: '#8580FF',
    disScenes: [
      $t('qi-ye-gong-zhong-hao-mei-ti-zhang-hao'),
      $t('qi-ye-nei-pei'),
      $t('qi-ye-zhi-bo-dai-huo'),
      $t('qi-ye-xian-shang-xian-xia-tui-guang'),
    ],
    disscenesColor: '#6962FF',
    disscenesBg: '#DDDCFF',
  },
  {
    name: $t('qi-ye-shang-yong-shou-quan'),
    desc: $t(
      'qi-ye-shang-yong-shou-quan-chan-pin-ji-shi-pin-ke-yi-zai-qi-ye-zhu-ti-de-mei-ti-zhang-hao-zhong-fa-bu-wei-qi-ye-zuo-xuan-chuan-tui-guang-qi-ye-fa-bu-hui-pei-xun-hui-deng-shang-shi-huo-dong',
    ),
    scenes: [
      $t('qi-ye-gong-zhong-hao-mei-ti-zhang-hao'),
      $t('qi-ye-nei-pei'),
      $t('qi-ye-zhi-bo-dai-huo'),
      $t('qi-ye-xian-shang-xian-xia-tui-guang'),
    ],
    scenesColor: '#FFFFFF',
    scenesBg: '#A07E3F',
    disScenes: [],
    isTip: true,
  },
]);

const onSubscribe = () => {
  if (props.onSubscribeCb) {
    props.onSubscribeCb();
  }
  actionUpdateCycle('team');
  navigateTo({ name: PageKey.SUBSCRIBE });
};
</script>
<style lang="scss" scoped>
.diff-0 {
  background: linear-gradient(180deg, #f1efff 0%, #f7f5ff 100%);
}
.diff-1 {
  background: linear-gradient(180deg, #fff5d1 0%, #fffaea 100%);
}
.diff {
  width: 420px;
  min-height: 460px;
  padding: 32px 28px;
  border-radius: 16px;
  &:nth-child(2) {
    margin-left: 18px;
  }
  h2 {
    font-weight: bold;
    font-size: 18px;
    color: var(--text-1);
    line-height: 26px;
    margin-top: 0;
    margin-bottom: 12px;
  }
  .desc {
    margin: 0;
    margin-bottom: 40px;
    font-weight: 400;
    font-size: 14px;
    color: var(--text-1-80);
    line-height: 24px;
  }
  .desc-title {
    font-weight: 500;
    font-size: 14px;
    color: var(--text-1);
    line-height: 20px;
    margin-top: 0;
    margin-bottom: 12px;
  }
  :deep(.ant-tag) {
    padding: 4px 12px;
    font-size: 14px;
    border-radius: 8px;
  }
  .tip {
    font-weight: 400;
    font-size: 14px;
    color: var(--warning-10);
    line-height: 24px;
    margin-top: 30px;
  }
  .tip-bold {
    cursor: pointer;
    font: bold;
    border-bottom: 2px solid #775538;
  }
}
</style>
